module.exports = require("core-js-pure/features/get-iterator");